import React from "react";
import { Fieldset, Label } from "@ui-kit/form";

export interface IProps {
  title: React.ReactNode;
  children: React.ReactNode;
}

const PanelsCardEditionSidebarLine = ({ title, children }: IProps) => (
  <Fieldset>
    <Label>{title}</Label>
    {children}
  </Fieldset>
);

export default PanelsCardEditionSidebarLine;
